import { render, staticRenderFns } from "./XmTip.vue?vue&type=template&id=727df7ea&scoped=true"
import script from "./XmTip.vue?vue&type=script&lang=js"
export * from "./XmTip.vue?vue&type=script&lang=js"
import style0 from "./XmTip.vue?vue&type=style&index=0&id=727df7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727df7ea",
  null
  
)

export default component.exports